<template>
  <div>
    <v-btn :color="ui.btnColor" flat @click="openDialog()"
    :disabled="disableStats"
    v-if="this.data.size === 'flat'">
      <v-icon left :color="ui.btnColor">
        assessment
      </v-icon>
      Stats
    </v-btn>
    <v-btn icon @click="openDialog()"
    :disabled="disableStats"
    v-else>
      <v-icon :color="ui.btnColor">
        assessment
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon medium left :color="ui.iconColor"> assessment </v-icon>
            <span :class="ui.textTitle">
              {{this.defineDocumentFromTag(data.tag).title}} Stats
            </span>
            <v-spacer/>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text>
          <v-layout row class="text-xs-left ml-4 mr-2">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
            v-if="this.basic.tag !== 'U1'">
              <v-avatar>
              <v-icon>
                {{this.defineDocumentFromTag(data.tag).icon}}
              </v-icon>
              </v-avatar>
              {{displayDocumentIDGTypeA(this.basic.tag, this.basic.idg)}}
            </v-chip>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
            v-else>
              <v-avatar>
              <v-icon>
                create
              </v-icon>
              </v-avatar>
              Created Documents
            </v-chip>
            <v-spacer/>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
            v-if="this.basic.link === true">
              <v-icon> link </v-icon>
            </v-chip>
            <!-- <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
            v-if="this.basic.save === true && this.basic.tag !== 'U1'">
              <v-icon :color="ui.btnColorWarning"> save </v-icon>
            </v-chip> -->
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
            v-if="this.basic.lock === true">
              <v-icon :color="ui.btnColorWarning"> lock </v-icon>
            </v-chip>
          </v-layout>
          <v-layout row class="text-xs-left ml-4 mr-2"
          v-if="this.basic.tag !== 'U1'">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> title </v-icon>
              </v-avatar>
              {{basic.title}}
            </v-chip>
            <v-spacer/>
          </v-layout>
          <v-layout row class="text-xs-left ml-4 mr-2"
          v-if="this.basic.tag !== 'U1'">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> sell </v-icon>
              </v-avatar>
              {{basic.id}}
            </v-chip>
            <v-spacer/>
          </v-layout>
          <!-- USER INFO -->
          <v-layout class="mt-4"/>
          <!-- USER / FACILITY / ASSETS -->
          <v-layout class="mt-2"/>


          <div class="mt-4" v-if="enableBusinessStats">
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="true">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> bar_chart </v-icon>
                </v-avatar>
                Business Processes
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nb1 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                  <v-icon> {{this.defineDocumentFromTag("B1").icon}} </v-icon>
                </v-avatar>
                {{this.defineDocumentFromTag("B1").titles}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ stats.nb1 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nb3 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("B3").icon}} </v-icon>
                </v-avatar>
                {{this.defineDocumentFromTag("B3").titles}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ stats.nb3 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nb4 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("B4").icon}} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("B4").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ stats.nb4 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nb6 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("B6").icon }} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("B6").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ stats.nb6 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nb7 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("B7").icon }} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("B7").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ stats.nb7 }}
              </v-chip>
            </v-layout>
          </div>

          <div class="mt-4" v-if="enableSafetyStats">
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="true">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> health_and_safety </v-icon>
                </v-avatar>
                Health and Safety
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.ns1 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("S1").icon}} </v-icon>
                </v-avatar>
                {{this.defineDocumentFromTag("S1").titles}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{ this.stats.ns1 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.ns2 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("S2").icon}} </v-icon>
                </v-avatar>
                {{this.defineDocumentFromTag("S2").titles}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ this.stats.ns2 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.ns3 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("S3").icon}} </v-icon>
                </v-avatar>
                {{this.defineDocumentFromTag("S3").titles}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ this.stats.ns3 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.ns4 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("S4").icon}} </v-icon>
                </v-avatar>
                {{this.defineDocumentFromTag("S4").titles}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ this.stats.ns4 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.ns5 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("S5").icon}} </v-icon>
                </v-avatar>
                {{this.defineDocumentFromTag("S5").titles}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ this.stats.ns5 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.ns6 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("S6").icon}} </v-icon>
                </v-avatar>
                {{this.defineDocumentFromTag("S6").titles}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{ stats.ns6 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.ns7 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("S7").icon}} </v-icon>
                </v-avatar>
                {{this.defineDocumentFromTag("S7").titles}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ stats.ns7 }}
              </v-chip>
            </v-layout>
          </div>

          <div class="mt-4" v-if="enableResourcesStats">
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="true">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> grid_view </v-icon>
                </v-avatar>
                Plan and Resources
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nh5 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("H5").icon }} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("H5").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ stats.nh5 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nl5 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("L5").icon }} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("L5").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ stats.nl5 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nq1 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("Q1").icon }} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("Q1").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{ stats.nq1 }}
              </v-chip>
            </v-layout>
          </div>

          <div class="mt-4" v-if="enableProceduresStats">
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="true">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> feed </v-icon>
                </v-avatar>
                Procedures and Results
              </v-chip>
            </v-layout>

            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nw5 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("W5").icon }} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("W5").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ stats.nw5 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.ne5 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("E5").icon }} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("E5").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ stats.ne5 }}
              </v-chip>
            </v-layout>
          </div>

          <div class="mt-4" v-if="enableOperationsStats">
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="true">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> person </v-icon>
                </v-avatar>
                Operations Systems
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.no1 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("O1").icon }} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("O1").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ stats.no1 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.no5 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("O5").icon }} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("O5").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ stats.no5 }}
              </v-chip>
            </v-layout>
          </div>

          <div class="mt-4" v-if="enableMaintenanceStats">
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="true">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> build </v-icon>
                </v-avatar>
                Maintenance and Work
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nm1 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("M1").icon}} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("M1").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <!-- {{ getDetailRelps.nm1.length }}  / {{ stats.nm1 }} -->
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nm2 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("M2").icon}} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("M2").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{ stats.nm2 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nm5 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("M5").icon}} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("M5").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ stats.nm5 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nm7 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("M7").icon}} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("M7").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ stats.nm7 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nw1 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("W1").icon}} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("W1").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip
              :color="ui.bkgdColor" :class="ui.textSubheading">
              {{ stats.nw1 }}
              </v-chip>
            </v-layout>
            <!-- <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nw2 !== undefined && this.basic.tag !== 'U1'">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("W2").icon}} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("W2").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ stats.nw2 }}
              </v-chip>
            </v-layout> -->
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nw6 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("W6").icon }} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("W6").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{ stats.nw6 }}
              </v-chip>
            </v-layout>
          </div>

          <div class="mt-4" v-if="enableTechnicalStats">
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="true">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> engineering </v-icon>
                </v-avatar>
                Technical Processes
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.ne2 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("E2").icon }} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("E2").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{ stats.ne2 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.ne3 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("E3").icon}} </v-icon>
                </v-avatar>
                  {{this.defineDocumentFromTag("E3").titles}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{ stats.ne3 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.ne6 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("E6").icon }} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("E6").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{ stats.ne6 }}
              </v-chip>
            </v-layout>
          </div>

          <div class="mt-4" v-if="enableRegisterStats">
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="true">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> reorder </v-icon>
                </v-avatar>
                Registers
              </v-chip>
            </v-layout>
            <v-layout class="text-xs-left ml-4 mr-2"
            v-if="stats.nc1 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("C1").icon}} </v-icon>
                </v-avatar>
                {{this.defineDocumentFromTag("C1").titles}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{stats.nc1}}
              </v-chip>
            </v-layout>
            <v-layout class="text-xs-left ml-4 mr-2"
            v-if="stats.nf1 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("F1").icon}} </v-icon>
                </v-avatar>
                {{this.defineDocumentFromTag("F1").titles}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{stats.nf1}}
              </v-chip>
            </v-layout>
            <v-layout class="text-xs-left ml-4 mr-2"
            v-if="stats.na1 !== undefined && this.getDetailBasic.tag !== 'C1'">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("A1").icon}} </v-icon>
                </v-avatar>
                {{this.defineDocumentFromTag("A1").titles}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{stats.na1}}
              </v-chip>
            </v-layout>
            <v-layout class="text-xs-left ml-4 mr-2"
            v-if="stats.ne1 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("E1").icon}} </v-icon>
                </v-avatar>
                {{this.defineDocumentFromTag("E1").titles}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{stats.ne1}}
              </v-chip>
            </v-layout>
            <v-layout class="text-xs-left ml-4 mr-2"
            v-if="stats.nl1 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("L1").icon}} </v-icon>
                </v-avatar>
                {{this.defineDocumentFromTag("L1").titles}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{stats.nl1}}
              </v-chip>
            </v-layout>
            <v-layout class="text-xs-left ml-4 mr-2"
            v-if="stats.nl7 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("L7").icon}} </v-icon>
                </v-avatar>
                {{this.defineDocumentFromTag("L7").titles}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{stats.nl7}}
              </v-chip>
            </v-layout>
            <v-layout class="text-xs-left ml-4 mr-2"
            v-if="stats.nu1 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{this.defineDocumentFromTag("U1").icon}} </v-icon>
                </v-avatar>
                {{this.defineDocumentFromTag("U1").titles}}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{stats.nu1}}
              </v-chip>
            </v-layout>
          </div>

          <div class="mt-4" v-if="enableGeneralStats">
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="true">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> scatter_plot </v-icon>
                </v-avatar>
                General Stats
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.ng4 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("G4").icon }} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("G4").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{ stats.ng4 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nk4 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("K4").icon }} </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("K4").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              {{ stats.nk4 }}
              </v-chip>
            </v-layout>
            <v-layout row class="text-xs-left ml-4 mr-2"
            v-if="stats.nd4 !== undefined">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> {{ this.defineDocumentFromTag("D4").icon }}  </v-icon>
                </v-avatar>
                {{ this.defineDocumentFromTag("D4").titles }}
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{ stats.nd4 }}
              </v-chip>
            </v-layout>
          </div>

        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-spacer/>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument";

export default {
  data() {
    return {
      dialog: false,
      valid: false,
      indeterminateProgressBar: false
    };
  },
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailRev",
      "getDetailBasic",
      "getCurrentPage",
      "stats",
      "getDetailRelps",
      "getDetailStats",
      "getUser",
      "getUserStats"
    ]),
    stats() {
      let stats = null;
      if (this.data.tag === "U1") {
        stats = this.getUserStats;
      } else {
        stats = this.getDetailStats;
      }
      return stats;
    },
    basic() {
      let stats = null;
      if (this.data.tag === "U1") {
        stats = this.getUser.basic;
      } else {
        stats = this.getDetailBasic;
      }
      return stats;
    },
    relps() {
      return this.getDetailRelps;
    },
    tag() {
      return this.basic.tag;
    },
    dp() {
      let dp = null;
      if (this.basic.rdp === "") {
        dp = "Not Signed";
      } else {
        dp = this.basic.rdp;
      }
      return dp;
    },
    tc() {
      let tc = null;
      if (this.basic.rtc === "") {
        tc = "Not Signed";
      } else {
        tc = this.basic.rtc;
      }
      return tc;
    },
    disableStats() {
      // DO NOT DISPLAY BAD DATA STATS for
      // COMPANY NOR FACILTY
      let logic = false;
      if (this.getCurrentPage === "/companymanagement") {
        if (this.getDetailStats === null) {
          logic = true;
        } else if (this.getDetailStats.n < 1) {
          logic = true;
        } else if (this.getDetailStats.nf1 === undefined) {
          logic = true;
        } else if (this.getDetailStats.dsin !== undefined) {
          logic = true;
        } else {
          logic = false;
        }
      } else if (this.getCurrentPage === "/facilitymanagement") {
        if (this.getDetailStats === null) {
          logic = true;
        } else if (this.getDetailStats.n < 1) {
          logic = true;
        } else if (this.getDetailStats.nf1 !== undefined) {
          logic = true;
        } else if (this.getDetailStats.dsin !== undefined) {
          logic = true;
        } else {
          logic = false;
        }
      } else if (this.getCurrentPage === "/reportdetail") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableBusinessStats() {
      let logic = null;
      if (
        this.stats.nb1 !== undefined ||
        this.stats.nb3 !== undefined ||
        this.stats.nb4 !== undefined ||
        this.stats.nb6 !== undefined ||
        this.stats.nb7 !== undefined
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableTechnicalStats() {
      let logic = null;
      if (
        this.stats.ne2 !== undefined ||
        this.stats.ne3 !== undefined ||
        this.stats.ne6 !== undefined
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableSafetyStats() {
      let logic = null;
      if (
        this.stats.ns1 !== undefined ||
        this.stats.ns2 !== undefined ||
        this.stats.ns3 !== undefined ||
        this.stats.ns4 !== undefined ||
        this.stats.ns5 !== undefined ||
        this.stats.ns6 !== undefined
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableResourcesStats() {
      let logic = null;
      if (
        this.stats.nh5 !== undefined ||
        this.stats.nl5 !== undefined ||
        this.stats.nq1 !== undefined
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableProceduresStats() {
      let logic = null;
      // eslint-disable-next-line
      if (
        this.stats.ne5 !== undefined ||
        this.stats.nw5 !== undefined
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableOperationsStats() {
      let logic = null;
      // eslint-disable-next-line
      if (
        this.stats.no1 !== undefined ||
        this.stats.no5 !== undefined
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableMaintenanceStats() {
      let logic = null;
      if (
        this.stats.nm1 !== undefined ||
        this.stats.nm2 !== undefined ||
        this.stats.nm5 !== undefined ||
        this.stats.nm7 !== undefined ||
        this.stats.nw1 !== undefined ||
        this.stats.nw2 !== undefined ||
        this.stats.nw6 !== undefined
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableRegisterStats() {
      let logic = null;
      if (
        this.stats.nc1 !== undefined ||
        this.stats.nf1 !== undefined ||
        this.stats.na1 !== undefined ||
        this.stats.ne1 !== undefined ||
        this.stats.nl1 !== undefined ||
        this.stats.nl7 !== undefined ||
        this.stats.nu1 !== undefined
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableGeneralStats() {
      let logic = null;
      if (
        this.stats.ng4 !== undefined ||
        this.stats.nd4 !== undefined ||
        this.stats.nk4 !== undefined
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  // eslint-disable-next-line
  mixins: [apptheme, dateFunctions, displayFunctions, describeDocument],
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    }
  }
};
</script>
